/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgHeartbeat = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M16.262 3a5.69 5.69 0 0 1 4.063 1.713A5.873 5.873 0 0 1 22 8.828a5.873 5.873 0 0 1-1.674 4.114L12 21.428l-8.327-8.486c-2.231-2.275-2.231-5.953 0-8.228a5.676 5.676 0 0 1 8.128 0l.199.202.199-.203a5.7 5.7 0 0 1 3.795-1.707zm-.762 8.053-3.506 4.605-2.979-3.972L8.067 13H6.532l5.467 5.572 5.469-5.573-.67.001zM16.262 5c-.986 0-1.935.4-2.636 1.114L12 7.774l-1.627-1.66a3.676 3.676 0 0 0-5.272 0C3.799 7.442 3.651 9.506 4.659 11h2.384l1.942-2.687 3.021 4.028 3.604-4.73L17.868 11h1.472c.427-.634.66-1.39.66-2.172 0-1.02-.397-1.996-1.102-2.714A3.693 3.693 0 0 0 16.262 5z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgHeartbeat as Heartbeat };
